import { Component, OnInit } from '@angular/core';
import { NxiNavigation } from '@pershing/nxi-common';
import { INavigationService, PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'bread-crumb',
    templateUrl: 'breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {
    parent: any;
    child: any;
    grandChild: any;
    fourthChild: any;
    navigation: NxiNavigation;
    // hide breadcrumbs for few ADA pages
    // Ideally this should come from menu-config
    // We need to enhance menu-config so we only put deltas for customized IBDs
    // Today it is an entire copy. There are 17 copies now.
    // Adding it here -- and will be revisited once menu-config is enhanced
    // hlakshmanan
    // Add list of links that should not be part of breadcrumbs
    secondLevelBreadCrumbsToHide: string[] = [
        'NXI_NAVIGATION.SETTINGS'
    ];

    constructor(private navigationService: INavigationService,
                private translationService: PershingTranslationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-navigation', 'node_modules/@pershing/nxi-navigation/lib');
    }
    ngOnInit() {
        this.navigationService.getParentPage().subscribe(
            (data: any) => this.parent = data
        );
        this.navigationService.getChildPage().subscribe(
            (data: any) => this.child = data
        );
        this.navigationService.getGrandChildPage().subscribe(
            (data: any) => {
                this.grandChild = data;
                this.fourthChild = null;
            }
        );
        this.navigationService.getFourthChildPage().subscribe(
            (data: any) => this.fourthChild = data
        );
    }
    handleNavigation(): void {
        this.navigation = new NxiNavigation();
        this.navigation.parentPage = this.parent;
        this.navigation.childPage = this.getFirstChild(this.parent);
        this.navigation.grandchildPage = this.getFirstChild(this.navigation.childPage);
        this.navigationService.handleNavigation(this.navigation);
    }
    handleChildNavigation(): void {
        this.navigation = new NxiNavigation();
        this.navigation.parentPage = this.parent;
        this.navigation.childPage = this.child;
        this.navigation.grandchildPage = this.getFirstChild(this.child);
        this.navigationService.handleNavigation(this.navigation);
    }
    handleGrandChildNavigation(): void {
        this.navigation = new NxiNavigation();
        this.navigation.parentPage = this.parent;
        this.navigation.childPage = this.child;
        if (this.grandChild.hideFromNavigation) {
            this.navigation.childPage = this.grandChild;
        } else {
            this.navigation.grandchildPage = this.grandChild;
        }
        this.navigationService.handleNavigation(this.navigation);
    }
    handleFourthChildNavigation(fourthchildPage): void {
        this.navigation = new NxiNavigation();
        this.navigation.fourthchildPage = fourthchildPage;
        this.navigationService.handleNavigation(this.navigation);
    }

    getFirstChild(navMenu: any): any {
        if (navMenu && navMenu.children && navMenu.children.length > 0) {
            return navMenu.children[0];
        }
        return null;
    }
}
